import React from 'react';
import { FaEnvelope, FaPhone, FaGlobe } from 'react-icons/fa';
import './Pricing.scss';

const Pricing: React.FC = () => {
  const whatsappNumber = '56926974928';
  return (
    <div className="pricing">
      <div className="pricing__image">
        <img
          src={process.env.PUBLIC_URL + '/web_page_images/Pricing.jpg'}
          alt="Pricing"
        />
      </div>
      <div className="pricing__content">
        <span className="pricing__label">Empezar es simple</span>
        <h3 className="pricing__title">Planes que se adaptan a ti</h3>
        <p className="pricing__subtitle">Sin letra chica. Sin cargos ocultos.</p>
        <hr className="pricing__divider" />
        <ul className="pricing__contacts">
          <li>
            <a href="mailto:ventas@mediopunto.cl">
              <FaEnvelope /> ventas@mediopunto.cl
            </a>
          </li>
          <li>
            <a
              href={`https://wa.me/${whatsappNumber}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaPhone /> +569 2697 4928
            </a>
          </li>
          <li>
            <a
              href="https://mediopunto.ai"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaGlobe /> mediopunto.ai
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Pricing;
